import useAsyncData from "../../../hooks/use-async-data";
import CandidaturePreviewParams from "./candidature-preview-params";
import CandidaturePreview from "./candidature-preview";
import candidatureService from "../candidature.service";
import { useState } from "react";
import CandidaturePreviewError from "./candidature-preview-error";

const useCandidaturePreview = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<CandidaturePreview | null>(null);
  const [error, setError] = useState<CandidaturePreviewError | null>(null);

  const load = async (
    params: CandidaturePreviewParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);
    setError(null);

    try {
      const candidaturePreview = await candidatureService.getPreview(
        params,
        signal,
      );

      setData(candidaturePreview);
    } catch (_error) {
      setIsError(true);
      setError(_error as CandidaturePreviewError);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    error,
    load,
  };
};

export default useCandidaturePreview;
